<template>
    <page>
		<module title="表格字段管理">
			<module-column width="210" scroll>
				<div class="tree">
					<c-tree ref="tree" :props="{'name': 'menu_name'}" :load="loadTree" @node-click="nodeClickHandle"></c-tree>
				</div>
			</module-column>
			
			<module-column scroll>
				<div v-for="(item, i) in dataList" :key="i" class="table-list">
					<div class="table-handle flex-between-center">
						<p>展示字段配置【{{item.list_name}}】</p>
						<c-button color="gray" hollow @click="addField(item.list_unique_code)">添加字段</c-button>
					</div>
					<c-table ref="table" v-model="item.field_list" height="auto" border>
						<c-table-column
							label="字段名称"
							name="field_name"
						></c-table-column>
						
						<c-table-column
							label="是否显示"
						>
							<template v-slot="{data}">
								{{data.default_display == 1 ? '显示' : '隐藏'}}
							</template>
						</c-table-column>
						
						<c-table-column
							label="是否锁定"
						>
							<template v-slot="{data}">
								{{data.is_locked == 1 ? '未锁定' : '锁定'}}
							</template>
						</c-table-column>
						
						<c-table-column
							type="sort"
							label="排序"
							@sort="sortHandle"
						></c-table-column>
								
						<c-table-column
							type="button"
							fixed="right"
							label="操作"
							width="110"
						>
							<template v-slot="row">
								<c-table-button v-if="row.data.default_display == 1" @click="displayHandle(2, row)">隐藏</c-table-button>
								<c-table-button v-else @click="displayHandle(1, row)">显示</c-table-button>
								<c-table-button @click="deleteHandle(row)">移除</c-table-button>
								<c-table-button v-if="row.data.is_locked == 1" @click="lockedHandle(2, row)">锁定</c-table-button>
								<c-table-button v-else @click="lockedHandle(1, row)">解锁</c-table-button>
							</template>
						</c-table-column>
					</c-table>
				</div>
			</module-column>
		</module>
		
		<c-dialog ref="dialog" title="添加字段" width="600" @resolve="addFieldHandle">
			<div class="field">
				<div class="field-list">
					<div class="field-item">
						<c-checkbox :checked="fieldAllCheck" @click="checkField('all', $event)">全选</c-checkbox>
					</div>
					<div class="field-list">
						<div v-for="(item, i) in fieldList" :key="i" class="field-item">
							<c-checkbox :checked="item.checked" @click="checkField(item, $event)">{{item.field_name}}</c-checkbox>
						</div>
					</div>
				</div>
			</div>
		</c-dialog>
	</page>
</template>

<script>
	import cTree from '@/components/unit/tree.vue'
	
	export default {
		name: 'm_system_menu_field',
		
		components: {
			cTree
		},
		
		data() {
			return {
				dataList: [],
				fieldList: []
			}
		},
		
		computed: {
			fieldAllCheck() {
				return !!(this.fieldList.length && !this.fieldList.find(item => !item.checked));
			}
		},
		
		methods: {
			loadTree(node, resolve) {
				this.request({
					url: '/system_menu/get_sub_menu',
					data: {
						menu_id: node ? node.data.id : 1
					},
					success: data => {
						data.forEach(item => {
							if (item.menu_type == 2) {
								item.leaf = true;
							}
						});
						resolve(data);
					}
				});
			},
			
			nodeClickHandle(node) {
				if (node.data.menu_type != 2) return;
				this._node = node;
				this.request({
					url: '/system_table_field/get_table_list',
					data: {
						menu_id: node.data.id
					},
					success: data => {
						this.dataList = data;
					}
				});
			},
			
			addField(code) {
				this.request({
					url: '/system_table_field/get_table_field_list',
					data: {
						list_unique_code: code,
						enable_state: 2
					},
					loading: true,
					success: data => {
						if (!data.length) {
							this.$message({
								text: '暂无可添加的字段'
							});
							return;
						}
						this.fieldList = data;
						this.$refs.dialog.open();
					}
				});
			},
			
			checkField(item, state) {
				if (item == 'all') {
					this.fieldList.forEach(item => {
						this.checkField(item, state);
					});
				} else {
					this.$set(item, 'checked', state);
				}
			},
			
			addFieldHandle(stop) {
				stop();
				var checked = this.fieldList.filter(item => item.checked);
				
				if (!checked.length) {
					this.$message({
						text: '请选择要添加的字段'
					});
					return;
				}
				
				this.request({
					url: '/system_table_field/edit',
					data: {
						edit_type: '02',
						menu_field_ids: Array.from(checked, item => item.id),
						enable_state: 1
					},
					loading: true,
					success: () => {
						this.$refs.dialog.close();
						this.nodeClickHandle(this._node);
					}
				});
			},
			
			sortHandle(row, type, next) {
				this.request({
					url: '/system_table_field/sort',
					data: {
						sort_type: type == 'top' ? '01' : type == 'bottom' ? '02' : '03',
						menu_field_id: row.data.id,
						target_menu_field_id: type == 'up' ? row.prev().data.id : type == 'down' ? row.next().data.id : '',
					},
					loading: true,
					success: data => {
						next();
					}
				});
			},
			
			displayHandle(state, row) {
				this.request({
					url: '/system_table_field/edit',
					data: {
						edit_type: '01',
						menu_field_ids: [row.data.id],
						default_display: state,
						enable_state: row.data.enable_state
					},
					loading: true,
					success: () => {
						row.data.default_display = state;
					}
				});
			},
			
			deleteHandle(row) {
				this.$confirm({
					text: '确认要移除该字段吗？',
					resolve: () => {
						this.request({
							url: '/system_table_field/edit',
							data: {
								edit_type: '02',
								menu_field_ids: [row.data.id],
								enable_state: 2
							},
							loading: true,
							success: data => {
								row.remove();
							}
						});
					}
				});
			},
			
			lockedHandle(state, row) {
				this.$confirm({
					text: state == 1 ? '解锁字段后，该字段排序将置底，你确定要解锁此字段吗？' : '锁定字段后，该字段排序将置顶，你确定要锁定此字段吗？',
					resolve: () => {
						this.request({
							url: '/system_table_field/edit',
							data: {
								edit_type: '03',
								menu_field_ids: [row.data.id],
								is_locked: state,
								enable_state: row.data.enable_state
							},
							loading: true,
							success: () => {
								row.data.is_locked = state;
								row.moveTo(state == 1 ? 'bottom' : 'top');
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.tree {
		min-height: 100%;
		background: #F9FAFC;
	}
	
	.table {
		&-list {
			margin: 0 20px 20px;
		}
		
		&-handle {
			height: 64px;
			
			p {
				font-size: 15px;
				color: #333;
			}
		}
	}
	
	.field {
		height: 300px;
		overflow: auto;
		
		&-list {
			clear: both;
			overflow: hidden;
			
			.field-list {
				margin-left: 40px;
				margin-bottom: 20px;
			}
		}
		
		&-item {
			float: left;
			margin-top: 15px;
			margin-left: 20px;
		}
	}
</style>